module.exports = __webpack_public_path__ + "img/home_en_US_img1.98251cba.png";